<template>
    <v-container fluid class="scroll-y fullscreen" pa-0>
        <v-card
            class="mx-auto"
            flat
            :loading="loading"
            loader-height="10"
            tile
        >
            <v-toolbar
            color="#003a6f"
            dark
            flat
            >
                <v-toolbar-title>{{ pageTitle }}</v-toolbar-title>
            </v-toolbar>
        </v-card>
        <v-card flat tile class="mx-auto overflow-hidden" min-height="calc(100vh - 112px)" color="#004889">
            <v-card flat color="#004889">
                <v-card-text class="pa-0">
                    <ValidationObserver ref="observer1">
                        <v-form ref="jobFields">
                            <v-list flat color="#004889" class="py-0">
                                <v-list-item class="form-row">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">Job #</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-text-field
                                            v-model="form.job_no"
                                            solo
                                            dark
                                            flat
                                            required
                                        ></v-text-field> 
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">Customer</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action class="justify-end">
                                        <div class="d-flex align-center f-wrap">
                                            <ValidationProvider v-slot="{ errors }" name="Customer" rules="required">
                                                <v-autocomplete
                                                    v-model="form.customer"
                                                    :items="customers"
                                                    :loading="isLoading"
                                                    :search-input.sync="search"
                                                    hide-no-data
                                                    hide-selected
                                                    item-text="label"
                                                    item-value="value"
                                                    placeholder="Start typing to Search"
                                                    return-object
                                                    required
                                                    :error-messages="errors"
                                                    solo
                                                    flat
                                                    dark
                                                    class="customer-autocomplete"
                                                ></v-autocomplete>
                                            </ValidationProvider>
                                            <v-btn
                                                class="ml-1"
                                                fab
                                                dark
                                                small
                                                text
                                                :to="{ name:'New Customer', params: { redirect: 'New Job' } }"
                                            >
                                                <v-icon dark>
                                                    mdi-plus
                                                </v-icon>
                                            </v-btn>
                                        </div>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">Contract Date</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-menu
                                            v-model="menu"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="computedDateFormatted"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                                solo
                                                flat
                                                dark
                                            ></v-text-field>
                                            </template>
                                            <v-date-picker
                                            v-model="form.date"
                                            @input="menu = false"
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">Supervisor</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <ValidationProvider v-slot="{ errors }" name="Supervisor" rules="required">
                                            <v-select
                                                v-model="form.users.supervisor"
                                                :items="users"
                                                item-text="name"
                                                item-value="id"
                                                label="Supervisor"
                                                :error-messages="errors"
                                                clearable
                                                solo
                                                flat
                                                dark
                                                hide-details
                                            ></v-select>
                                        </ValidationProvider>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">Start Date</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-menu
                                            v-model="menu"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="computedStartDateFormatted"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                                solo
                                                flat
                                                dark
                                            ></v-text-field>
                                            </template>
                                            <v-date-picker
                                            v-model="form.start_date"
                                            @input="menu = false"
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">Contract Amount</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <ValidationProvider v-slot="{ errors }" name="Contract Amount" rules="required">
                                            <v-text-field
                                                v-model="form.amount"
                                                prefix="$"
                                                required
                                                :error-messages="errors"
                                                solo
                                                flat
                                                dark
                                            ></v-text-field>
                                        </ValidationProvider>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">Contract Amount Type</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-select
                                            v-model="form.contract_amount_type"
                                            :items="amountTypes"
                                            item-text="label"
                                            item-value="value"
                                            required
                                            :error-messages="errors"
                                            solo
                                            flat
                                            dark
                                        ></v-select>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">Deposit Amount</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-text-field
                                            v-model="form.deposit_amount"
                                            prefix="$"
                                            solo
                                            flat
                                            dark
                                        ></v-text-field>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">Deposit Amount Type</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-select
                                            v-model="form.deposit_amount_type"
                                            :items="amountTypes"
                                            item-text="label"
                                            item-value="value"
                                            required
                                            :error-messages="errors"
                                            solo
                                            flat
                                            dark
                                        ></v-select>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">Status</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-select
                                            v-model="form.status"
                                            :items="filteredStatuses"
                                            item-text="label"
                                            item-value="value"
                                            required
                                            :error-messages="errors"
                                            solo
                                            flat
                                            dark
                                        ></v-select>
                                    </v-list-item-action>
                                </v-list-item>
                               <v-list-item class="form-row">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">Select a Size</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-select
                                            v-model="form.size"
                                            :items="sizes"
                                            item-text="title"
                                            item-value="id"
                                            data-vv-name="size"
                                            solo
                                            flat
                                            dark
                                            hide-details
                                        ></v-select>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row" v-if="form.size == 999">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">Define the Size</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-text-field
                                            v-model="form.other_size"
                                            solo
                                            dark
                                            flat
                                            hide-details
                                            :readonly="userRole == 'finishing_crew'"
                                        ></v-text-field> 
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">Select a Shape</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-select
                                            v-model="form.shape"
                                            :items="shapes"
                                            item-text="title"
                                            item-value="id"
                                            data-vv-name="shape"
                                            solo
                                            flat
                                            dark
                                            hide-details
                                        ></v-select>   
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">Deck Color</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-text-field
                                            v-model="form.deck_color"
                                            solo
                                            dark
                                            flat
                                            hide-details
                                        ></v-text-field> 
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">Pool Addons</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-select
                                            v-model="form.pooloptions"
                                            :items="options"
                                            item-text="title"
                                            item-value="id"
                                            multiple
                                            small-chips
                                            solo
                                            flat
                                            dark
                                            hide-details
                                        >
                                        </v-select>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row" v-if="form.pooloptions && form.pooloptions.includes(4)">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">No of LED's</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-text-field
                                            v-model="form.noofled"                                         
                                            solo
                                            dark
                                            flat
                                            hide-details
                                            :readonly="userRole == 'finishing_crew'"
                                        ></v-text-field> 
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row" v-if="form.pooloptions && form.pooloptions.includes(5)">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">No of Bubblers</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-text-field
                                            v-model="form.noofbubblers"                                         
                                            solo
                                            dark
                                            flat
                                            hide-details
                                            :readonly="userRole == 'finishing_crew'"
                                        ></v-text-field> 
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row" v-if="form.pooloptions && form.pooloptions.includes(9)">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">Waterfall Color</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-text-field
                                            v-model="form.waterfall_color"                                         
                                            solo
                                            dark
                                            flat
                                            hide-details
                                        ></v-text-field> 
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">Extra Concrete</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-select
                                            v-model="form.extra_concrete"
                                            :items="yes_no"
                                            item-text="label"
                                            item-value="value"
                                            solo
                                            flat
                                            dark
                                            hide-details
                                        ></v-select>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">Retaining Wall</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-select
                                            v-model="form.retaining_wall"
                                            :items="yes_no"
                                            item-text="label"
                                            item-value="value"
                                            solo
                                            flat
                                            dark
                                            hide-details
                                        ></v-select>
                                    </v-list-item-action>
                                </v-list-item> 
                                <v-list-item class="form-row" v-if="form.retaining_wall == 'yes'">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">Retaining Wall Data</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-text-field
                                            v-model="form.retaining_wall_data"
                                            solo
                                            dark
                                            flat
                                            hide-details
                                            :readonly="userRole == 'finishing_crew'"
                                        ></v-text-field> 
                                    </v-list-item-action>
                                </v-list-item>                            
                                <v-list-item class="form-row">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">Liner Color</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-select
                                            v-model="form.liner_color"
                                            :items="liner_color"
                                            solo
                                            flat
                                            dark
                                            hide-details
                                        ></v-select>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">Comments</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-textarea
                                            v-model="form.additional_comments"
                                            solo
                                            dark
                                            flat
                                            hide-details
                                        ></v-textarea> 
                                    </v-list-item-action>
                                </v-list-item>
                            </v-list>
                        </v-form>
                    </ValidationObserver>
                </v-card-text> 
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn large min-width="98%" color="white accent--text"  @click="submit" :loading="loading" tile>Create</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions> 
            </v-card>
        </v-card>
        <AddCategory :dialog="categoryDialog" type="job_type" @update-dialog="updateCategoryDialog" @update-categories="updateCategories"/>
    </v-container>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import { required } from 'vee-validate/dist/rules'
    import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
    import axios from 'axios'
    import TokenService from '../../services/storage.service'
    import mixin from '../../mixin/main.js'
    import AddCategory from '../../components/AddCategory.vue'

    setInteractionMode('eager')

    extend('required', {
        ...required,
        message: '{_field_} can not be empty',
    })

    export default {
        mixins: [mixin],
        props: ['id'],
        data () {
            return {
                form: {
                    customer: {
                        label: '',
                        value: '',
                        object: []
                    },
                    status: 'active',
                    date: new Date().toISOString().substr(0, 10),
                    start_date: '',
                    amount: '',
                    contract_amount_type: '',
                    deposit_amount: '',
                    deposit_amount_type: '',
                    size: '',
                    other_size: '',
                    shape: '',
                    additional_comments: '',
                    pooloptions: [],
                    noofbubblers: '',
                    noofled: '',
                    liner_color: '',
                    deck: '',
                    deck_color: '',
                    border_color: '',
                    waterfall_color: '',
                    images: [],
                    comments: [],
                    activities: [],
                    extra_concrete: '',
                    retaining_wall: '', 
                    retaining_wall_data: '',
                    users: {
                        admin: '',
                        foreman: '',
                        salesperson: '',
                        technician: '',
                        cleaner: '',
                        supervisor: ''
                    },
                },
                search: null,
                isLoading: false,
                customers: [],
                loading: false,
                token: '',
                pageTitle: '',
                pool_types: [
                    { label: 'Liner Pool', value: 'liner' },
                    { label: 'Guinite', value: 'guinite' },
                ],
                categoryDialog: false,
                selectedCategory: null,
                yes_no: [
                    { label: 'Yes', value: 'yes' },
                    { label: 'No', value: 'no' },
                ],
            }
        },
        created() {
            this.token = TokenService.getToken()
            this.pageTitle = this.$route.meta.title
        },
        mounted() {
            if(this.$route.params.customer) {
                this.form.customer.label = this.$route.params.customer.title
                this.form.customer.value = this.$route.params.customer.id
                this.form.customer.object = this.$route.params.customer

                this.customers.push({...this.form.customer})
            }
        },
        components: {
            ValidationProvider,
            ValidationObserver,
            AddCategory
        },
        computed: {
            ...mapGetters({
                statuses: 'data/jobStatusArray',
                measurement_types: 'data/measurement_types',
                options: 'data/options',
                sizes: 'data/sizes',
                job_types: 'data/job_types',
                shapes: 'data/shapes',
                liner_color: 'data/liner_color',
                amountTypes: 'data/amountTypes',
                users: 'data/users',
            }),
            filteredStatuses() {
                return this.statuses.filter(status => {
                    return status.value != 'all'
                })
            },
            computedDateFormatted () {
                return this.formatDate(this.form.date)
            },
            computedStartDateFormatted () {
                return this.formatDate(this.form.start_date)
            },
        },
        watch: {
            search (val) {
                // Items have already been requested
                if (this.isLoading) return

                this.isLoading = true

                axios.get('crm/customers/search', {
                    params: {
                        keyword: val
                    }
                })
                .then(response => {
                    this.customers = response.data.customers
                    this.$nextTick()
                })
                .catch(err => {
                    console.log(err)
                })
                .finally(() => (this.isLoading = false))
            },
        },
        methods: {
            ...mapActions({
                addJob: 'data/addJob',
            }),
            async submit() {
                let valid1 = await this.$refs.observer1.validate()

                if(valid1) {
                    this.loading = true
                    this.addJob(this.form).then(response => {
                        this.loading = false
                        this.$store.commit('SET_SNACKTYPE', 'green')
                        this.$store.commit('SET_SNACK', 'Successfully saved!')
                        this.$router.push({ path: `/job/main/${response.id}` })
                    }).catch(error => {
                        this.loading = false
                        this.$store.commit('SET_SNACKTYPE', 'red')
                        if(error.response.data.error) {
                            this.$store.commit('SET_SNACK', error.response.data.error)
                        } else {
                            this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                        }
                    })
                } else {
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
                }
            },
            updateDrawer(val) {
                this.drawer = val
            },
            updateCategoryDialog(val) {
                this.categoryDialog = val
            },
            updateCategories(val) {
                this.form.job_type = val.id
            },
        }
    }
</script>

<style lang="sass">
.v-chip--select
    &.v-chip
        &.v-chip--clickable
            &.v-size--small
                background: #1976d2

.f-wrap
    width: 100%

    > span 
        min-width: calc(100% - 40px)

.label 
    .v-list-item__title
            white-space: inherit
</style>
